var cilInputHdmi = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M112,16V120H80V251.492l72,157.091V496H360V408.583l72-157.091V120H400V16Zm32,32H368v72H336V80H304v40H272V80H240v40H208V80H176v40H144ZM400,244.508,328,401.6V464H184V401.6L112,244.508V152H400Z' class='ci-primary'/>"];

export { cilInputHdmi };

